import { Note, NoteEditSessionSnapshotContent } from '../_service/data.service';

/** The editable-content subset of a note, in the shape stored in (and
 * restored from) an autosave Stage 2/3 opening snapshot. Mirrors exactly
 * what EditComponent.applyChangesToNoteFromForm() reads/writes, so a
 * snapshot's content is always structurally comparable to (and restorable
 * into) a live note. */
export function extractSnapshotContent(note: Note): NoteEditSessionSnapshotContent {
  return {
    Title: note.Title,
    DescriptionHtml: note.DescriptionHtml,
    DescriptionDelta: note.DescriptionDelta,
    CommentsHtml: note.CommentsHtml,
    CommentsDelta: note.CommentsDelta,
    Keywords: note.Keywords,
    AiKeywords: (note as any).AiKeywords,
    Status: note.Status,
    NoteType: note.NoteType,
    Confidential: note.Confidential,
    ReferenceDate: note.ReferenceDate,
    StartDate: note.StartDate,
    EndDate: note.EndDate,
    Categories: Array.isArray(note.Categories) ? [...note.Categories] : [],
    Tags: Array.isArray(note.Tags) ? [...note.Tags] : [],
    RelatedNotes: Array.isArray(note.RelatedNotes) ? [...note.RelatedNotes] : [],
  };
}

export function snapshotContentEquals(
  a: NoteEditSessionSnapshotContent,
  b: NoteEditSessionSnapshotContent,
): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
